"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatCards = exports.addCardMargin = void 0;
var _react = _interopRequireDefault(require("react"));
var _checkForExternalLink = _interopRequireDefault(require("../../utils/checkForExternalLink"));
var _BoundedCard = _interopRequireDefault(require("../BoundedCard/BoundedCard"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const imageSizes = {
  desktop: {
    width: 640,
    height: 360,
    ratio: {
      width: 55,
      height: 36
    }
  },
  tablet: {
    width: 640,
    height: 360,
    ratio: {
      width: 55,
      height: 36
    }
  },
  mobile: {
    width: 752,
    height: 423,
    ratio: {
      width: 55,
      height: 36
    }
  }
};
const formatCards = cards => {
  const GatsbyImage = cards?.GatsbyImage;
  const Link = cards?.Link;
  const renderBoundedCards = () => {
    if (cards && cards.length) {
      return cards.map((card, index) => {
        const cardContent = {
          eyebrow: card?.eyebrow,
          header: card?.header,
          image: card?.image,
          imageSizes: imageSizes,
          cardLink: card?.cardLink,
          bgColor: !card?.image ? "grey" : "",
          text: card?.text,
          GatsbyImage: GatsbyImage,
          Link: Link,
          cardAlignment: false,
          buttonSecondary: false
        };
        if (cardContent?.cardLink) {
          cardContent.cardLink.external = (0, _checkForExternalLink.default)(cardContent?.cardLink?.url);
        }
        return /*#__PURE__*/_react.default.createElement(_BoundedCard.default, {
          key: index,
          content: cardContent,
          contentfulId: card?.contentfulId
        });
      });
    }
  };
  return renderBoundedCards();
};
exports.formatCards = formatCards;
const addCardMargin = (wrapper, width) => {
  if (typeof wrapper !== "undefined") {
    const ele = wrapper?.querySelector(".mxp-products-package-container__left-section--card-container")?.querySelectorAll(".ter-bounded-card");
    const prodCards = ele ? Array.prototype.slice.call(ele) : [];
    if (prodCards?.length > 3 && width > "600") {
      prodCards.forEach(card => {
        card.style.margin = "0 30px 15px 0";
        card.style.minWidth = "250px !important";
      });
    } else if (prodCards?.length <= 3 && width > "600") {
      prodCards.forEach(card => {
        card.style.margin = "0 30px 20px 0";
      });
    } else {
      prodCards.forEach(card => {
        card.style.margin = "20px 0";
      });
    }
  }
};
exports.addCardMargin = addCardMargin;